module.exports = __webpack_public_path__ + "img/avatar-s-21.5aee13d8.png";